module.exports = __webpack_public_path__ + "assets/img/ticketpic.8ebb8b87.png";